import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import * as Action from './actions'
import { ToastService } from 'app/services/toast.service';
import { TowerService } from 'app/services/dal/tower.service';
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromTower from './reducer';
import { Router } from '@angular/router';



@Injectable()
export class TowerEffects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private router: Router,
    private service: TowerService,
    private toastService: ToastService) { }

  getTowers$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadItems),
        shouldLoadData(
          this.store,
          'towers',
          (action) => action.barId,
          fromTower.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'towers',
            action.barId,
            this.service.getItems(action.barId).pipe(
              map(items => Action.loadItemsSuccess({ items: items })),
              catchError(error => of(Action.loadItemsFailure({ error })))
            )
          )
        )
      );
  });


  updateTower$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.updateItem),
        mergeMap((action) => from(this.service.update(action.item))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.updateItemSuccess({ item: action.item });
            }),
            catchError(error => of(Action.updateItemFailure({ error })))
          )
        )
      );
  });



  addTower$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.addItem),
        mergeMap((action) => from(this.service.add(action.item, action.id))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.addItemSuccess({ item: action.item });
            }),
            catchError(error => of(Action.addItemFailure({ error })))
          )
        )
      );
  });


  deleteItem$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.deleteItem),
        mergeMap((action) => from(this.service.delete(action.id))
          .pipe(
            map(() => {
              this.toastService.deleteItemSuccess();
              return Action.deleteItemSuccess();
            }),
            catchError(error => of(Action.addItemFailure({ error })))
          )
        )
      );
  });


  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.softUpdate),
        mergeMap((action) => from(this.service.softUpdate(action.id, action.data, action.uid))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return Action.softUpdateSuccess({ id: action.id, data: action.data })
            }),
            catchError((error) => {
              return of(Action.softUpdateFailure({ error }))
            })
          )
        )
      );
  });



  setItemFromListPage$ = createEffect(
    () => {
      return this.actions$
        .pipe(

          ofType(
            Action.setItemFromListPage,
            Action.setItemAndNavigate
          ),
          tap((action) => {
            this.router.navigate(['/inventory/towers/details', action.id]);
          }),
        )
    },
    { dispatch: false }
  );


}
